import "./node_modules/leaflet/dist/leaflet.css";
import "./src/css/app.css";
import { wrapRootElement as wrap } from "./src/chakra-wrapper";

export const wrapRootElement = wrap;
require("prismjs/themes/prism-okaidia.css");
